export default __webpack_public_path__ + "static/vutlan-46e6d9cf1aa8863c06df0c141ea0b674.png";